<div class="modal-content">
    <div class="modal-header">
        <h6 class="modal-title" id="vcenter">{{ 'dataform.new_component.intant_component' | translate }}</h6>
        <a (click)="modal.close('')" type="button" class="close">×</a>
    </div>
    <div class="modal-body">
       <!-- <div class="row">
            <form class="form" [formGroup]="formComp">
                <div class="col-12">
                    <div class="form-group has-float-label">
                        <input  name="descriptionEn" 
                                class="form-control" 
                                formControlName="descriptionEn"
                                [class.is-invalid]="isValid('descriptionEn')"
                                id="descriptionEn" 
                                type="text" >
                        <label for="descriptionEn">{{ 'dataform.new_component.descriptionEn' | translate }}</label>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group has-float-label">
                        <input  name="descriptionEs" 
                                class="form-control" 
                                formControlName="descriptionEs"
                                [class.is-invalid]="isValid('descriptionEs')"
                                id="descriptionEs" 
                                type="text" >
                        <label for="descriptionEs">{{ 'dataform.new_component.descriptionEs' | translate }}</label>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group has-float-label">
                        <input  name="descriptionPt" 
                                class="form-control" 
                                formControlName="descriptionPt"
                                [class.is-invalid]="isValid('descriptionPt')"
                                id="descriptionPt" 
                                type="text" >
                        <label for="descriptionPt">{{ 'dataform.new_component.descriptionPt' | translate }}</label>
                    </div>
                </div>
            </form>
        </div>-->
        <p>{{ 'common.message.subtitle_save' | translate }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger claroredbg mr-1" (click)="newComponentInstance()">{{ 'common.btn.save' | translate }}</button>
        <button type="button" class="btn btn-danger claroredbg mr-1" (click)="modal.close('')">{{ 'common.btn.cancel' | translate }}</button>
    </div>
</div>
